/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-02-03 16:50:48
 * @Description: 
 */
import React, { useEffect } from "react";
import { IconArrawDown, IconRight } from "src/assets";
import urls from "src/constant/url";
import FTImageStore from "src/store/FTImageStore";
import { getAIGCLink } from "src/utils";
import FTLang from "src/utils/FTLang";
import "./FTLinkToAIGC.scss"
import FTAnalytic from "src/analyze/FTAnalytic";
export default function FTLinkToAIGC() {
  let [index] = React.useState(Math.random() > 0.5) 

  useEffect(() => {
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$show$fortor_ad',
      label: {
        location: 'goart_web_banner',
        button_position: 'avatar_banner',
        jump_url: getAIGCLink("toAvatar")
      }
    })
  },[])

  const handleClick = () => {
    const url = getAIGCLink("toAvatar"); 
    let popup = window.open(url)
    FTAnalytic.addAnalytic({
      type: 'ev',
      analyticType: "sa",
      action: 'fotor_web$click_up$fortor_ad',
      label: {
        location: 'goart_web_banner',
        button_position: 'avatar_banner',
        jump_url: url
      }
    })
    // let popup = window.open(`http://localhost.fotor.com:3001/app/features/aiimage.html?tooltype=cartoon`)
    if (FTImageStore.currentImage) {
      let callback = (res: any) => {
        if (res.data.type === "image_to_cartoon_ready") {
          popup!.postMessage(
            {
              type: "image_to_cartoon",
              fileList: [FTImageStore.currentImage]
            },
            "*"
          );
        }
      };
      // 监听打开图的事件
      window.addEventListener("message", callback, false);
    }
  }
  return <div className="link_to_aigc" onClick={handleClick}>
    <div className="link_to_aigc_background">
      <img src={urls.assetsUrl + "/img/aigc/aigc_background1.png"} alt="" />
      {/* <span>{ FTLang._("link_to_aigc_text") }</span> */}
    </div>
    <div className="link_to_aigc_content">
      {/* <img src={urls.assetsUrl + "/img/aigc/aigc_background1.png"} alt="" /> */}
      <div>
        <div>
          <span>{FTLang._("link_to_aigc_text")}</span>
          <div className="link_to_aigc_btn">
            {FTLang._("try_it_now")} <IconRight />
          </div>
        </div>
      </div>
    </div>
  </div>
}